import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";

export default function Guard({ role, children }) {
  const nav = useNavigate();
  const location = useLocation();
  const [state, setState] = useState("checking");
  const loginHref = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
  useEffect(() => {
    if (!localStorage.getItem("mastofa_token")) {
      setState("denied");
      nav(loginHref, { replace: true });
      return;
    }
    api("/auth/me")
      .then(({ user }) => {
        if (role && user.role !== role && user.role !== "ADMIN") {
          throw new Error("forbidden");
        }
        localStorage.setItem("mastofa_user", JSON.stringify(user));
        setState("allowed");
      })
      .catch(() => {
        localStorage.clear();
        setState("denied");
        nav(loginHref, { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);
  if (state !== "allowed")
    return (
      <div className="loading" data-testid="protected-route-state">
        {state === "checking"
          ? "Memeriksa sesi..."
          : "Anda tidak memiliki akses ke halaman ini."}
      </div>
    );
  return children;
}
